import React from 'react';
import { toJS } from 'mobx';
import ReactWebNotification from 'react-web-notification';
import { observer } from 'mobx-react-lite';
import { useRootStore } from '../../../../mobx/bridge';
import * as utils from '../../../../helpers/utils';

// eslint-disable-next-line prefer-arrow-callback,sonarjs/cognitive-complexity
const Notification = observer(function Notification() {
  const { commonStore, settingsStore, sendingEvents } = useRootStore();
  const settings = settingsStore.getLoggedUserSettings;

  commonStore.notificationRef = React.useRef(null);

  const handlePermissionGranted = () => {
    commonStore.setIgnoreNotifications(false);
  };

  const handlePermissionDenied = () => {
    commonStore.setIgnoreNotifications(true);
  };

  const handleNotSupported = () => {
    commonStore.setIgnoreNotifications(true);
  };

  const handleNotificationOnClick = () => {
    window.open('', utils.windowName).focus();

    if (settings.SelectedChannel?.Id !== commonStore.notificationsChannel.Id) {
      commonStore.setChatInputStyleHeight(0);
      commonStore.setFullModeChatFileUpload(null);

      sendingEvents.socketEmitRoom(
        commonStore.notificationsChannel,
        utils.maxNumberOfItemsByContainerSize(document, commonStore.messagesContainerRef)
      );
    }
  };

  return (
    <ReactWebNotification
      ref={commonStore.notificationRef}
      title={commonStore.notificationsTitle}
      options={toJS(commonStore.notificationsOptions)}
      ignore={commonStore.ignoreNotifications}
      notSupported={handleNotSupported}
      onPermissionGranted={handlePermissionGranted}
      onPermissionDenied={handlePermissionDenied}
      onClick={handleNotificationOnClick}
      timeout={0}
      askAgain
    />
  );
});
Notification.whyDidYouRender = true;
Notification.displayName = 'Main';

export default Notification;
